import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCT2dMLExAaDllwmTOGJFbBKIqy0g_FIDc",
  authDomain: "requirements-management-swg.firebaseapp.com",
  projectId: "requirements-management-swg",
  storageBucket: "requirements-management-swg.firebasestorage.app",
  messagingSenderId: "124925102293",
  appId: "1:124925102293:web:7cb045f73cbbea91567a5c"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};